module.exports = __webpack_public_path__ + "static/Obóz 2024 - ulotka_compressed-e472ee45215e4c529fcf521dc3677400.pdf";